import FontAwesome from 'react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';

import ManagedResourceList from '../shared/ManagedResourceList';
import PageHeader from '../PageHeader';
import Select from 'react-select';
import ScrollToTop from '../ScrollToTop';
import Img from 'react-image';
import dateFormat from '../../utils/dateFormat';
import MatchDetails from './MatchDetails';
import { stringParams } from 'utils';

import {entity as bulkFileWorkflows} from '../../ducks/bulkFileWorkflows';
import {entity as bulkFilePages} from '../../ducks/bulkFilePages';

import {duckify, filterDuck, singleDuck} from "../../utils/duckify";

import './styles/bulkFileWorkflow.scss';

const UPDATE_PROGRESS_STATUSES = [
  'pending',
  'processing',
  'ocr_matching',
  'committing'
];

class BulkFileWorkflow extends React.Component {
  static propTypes = {
    bulkFileWorkflowId: PropTypes.string.isRequired,
    bulkFilePages: PropTypes.arrayOf(PropTypes.object),
    page: PropTypes.number,

    getWorkflow: PropTypes.func,
    getBulkFilePages: PropTypes.func,
    commitWorkflow: PropTypes.func,

    bulkFileWorkflow: PropTypes.object
  };

  constructor() {
    super();

    this.state = {
      submitting: false,
      showMatchDetails: false
    }
  }

  componentDidMount(){
    this.props.getApplicableContacts(this.props.bulkFileWorkflowId);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { bulkFileWorkflow, bulkFileWorkflowId } = newProps;
    const { duckMeta = {} } = newProps;

    if (this.getWorkflowTimer) {
      clearTimeout(this.getWorkflowTimer);
    }

    if (duckMeta.bulkFileWorkflow.ready && UPDATE_PROGRESS_STATUSES.includes(bulkFileWorkflow.status)) {
      this.getWorkflowTimer = setTimeout(() => this.props.getWorkflow(bulkFileWorkflowId), 2000);
    }
  }

  setContact(contact_id){
    const {page=0, updatePage, bulkFilePages} = this.props;
    const currentPage = bulkFilePages[page];

    this.setState({
      submitting: true
    });

    updatePage({
      ...currentPage,
      contact_id
    })
    .catch(() => {})
    .then(() => {
      this.setState({
        submitting: false
      });
    });
  }

  commitWorkflow(){
    const {bulkFileWorkflow, commitWorkflow} = this.props;

    this.setState({
      submitting: true
    });

    commitWorkflow(bulkFileWorkflow)
    .catch(()=>{})
    .then(() => {
      this.setState({
        submitting: false
      });
    });
  }

  rotatePage(rotation){
    const {bulkFilePages, page=0, rotatePage} = this.props;
    const currentPage = bulkFilePages[page];

    this.setState({
      submitting: true
    });

    rotatePage(currentPage, rotation).then(()=>{
      this.setState({
        submitting: false
      });
    })
  }

  renderWaiting({reason, explanation}){
    return <div>
      <Link className='bulk-file-workflow-back' to='/setup/bulk_file_workflows'>
        <FontAwesome name='chevron-left' />
        &nbsp;Back to Bulk File Upload list
      </Link>

      <PageHeader header="Bulk File Upload"/>

      <div className="bulk-file-workflow-waiting">
        <div className="waiting-reason">
          {reason}
        </div>
        <div className="waiting-spinner">
          <FontAwesome name="spinner" spin/>
        </div>
        {explanation && <div className="waiting-explanation">
          {explanation}
        </div>}
      </div>
    </div>;
  }

  orderedContacts() {
    const {bulkFileWorkflow, bulkFilePages, page=0} = this.props;
    const currentPage = bulkFilePages[page];
    const matches = currentPage.matches || [];
    const {applicableContacts} = this.props;

    const contactDisplayGender = (contact) => {
      switch(contact.gender){
        case 'M':
        case 'm':
          return 'Male';
        case 'F':
        case 'f':
          return 'Female';
        default: return contact.gender_display;
      }
    };

    const contactDisplayName = (contact) => {
      const name = `${contact.last_name}, ${contact.first_name}`;
      const gender = contactDisplayGender(contact);
      const dob = contact.birth_date && dateFormat(contact.birth_date);

      const details = [gender, dob].filter((x)=>x).join(', ');

      return <div>
        {name}
        {details && <span className="match-details">&nbsp;({details})</span>}
      </div>;
    };

    const contactCanonicalName = (contact) => `${contact.last_name}, ${contact.first_name}`;

    const selectableMatches = matches.map((match)=>{
      const matchedContact = applicableContacts.find((c) => c.id == match.contact_id);

      return !!matchedContact && {
        value: matchedContact.id,
        label: <div className="auto-match">
          {contactDisplayName(matchedContact)}
        </div>,
        canonical_label: contactCanonicalName(matchedContact)
      };
    })
    .filter(m=>m);

    const selectableContacts = applicableContacts.map((contact) => ({
      value: contact.id,
      label: contactDisplayName(contact),
      canonical_label: contactCanonicalName(contact)
    }))
    .filter(x => !selectableMatches.find(y=> y.value == x.value));

    return [
      ...selectableMatches,
      {
        value: "UNMATCHED",
        label: <div className="non-match">NOT MATCHED</div>,
        canonical_label: 'NOT MATCHED'
      },
      ...selectableContacts
    ];
  }

  renderUserMatching(){
    const {bulkFileWorkflow, bulkFilePages, page=0} = this.props;
    const currentPage = bulkFilePages[page];
    const {pageErrors} = this.props;

    const orderedContacts = this.orderedContacts();
    const {applicableContacts=[]} = this.props;

    const {showMatchDetails} = this.state;

    return <ScrollToTop>
      <div className={`bulk-file-workflow-user-matching bulk-file-page-${page}`}>
        <Link className='bulk-file-workflow-back' to='/setup/bulk_file_workflows'>
          <FontAwesome name='chevron-left' />
          &nbsp;Back to Bulk File Upload list
        </Link>

        <div className="user-match-page-header">
          <PageHeader header={`Bulk File Upload:
            ${bulkFileWorkflow.checklist_item.name} for
            ${bulkFileWorkflow.school_year.name} (page
            ${page + 1} of
            ${bulkFilePages.length})`}
          />
        </div>

        {pageErrors &&
          <div className="alert alert-danger">
            We're sorry.  Something went wrong updating the matches for this page.  Please try again.
          </div>
        }

        <div className="row">
          <div className="col-8">
            <a href={`/api/bulk_file_workflows/${bulkFileWorkflow.id}/download`} className="btn">
              <FontAwesome name="download"/> Download Original Document
            </a>
          </div>
          <div className="col-8 text-center">
            <button type="button"
                    data-bs-toggle="tooltip" title="Rotate Left"
                    className="btn btn-secondary"
                    onClick={()=>this.rotatePage(-90)}
                    disabled={!!this.state.submitting}>
              <FontAwesome name="rotate-left"/>
            </button>
            <button type="button"
                    className="btn btn-secondary"
                    data-bs-toggle="tooltip" title="Rotate Right"
                    onClick={()=>this.rotatePage(90)}
                    disabled={!!this.state.submitting}>
              <FontAwesome name="rotate-right"/>
            </button>
          </div>
          <div className="col-8 text-end">
            {global.is_super_admin && <button type="button" className="btn" onClick={()=>this.setState({showMatchDetails: !showMatchDetails})}>
              <FontAwesome name="gears"/> SuperAdmin Debug
            </button>
            }
          </div>
        </div>

        {showMatchDetails && <MatchDetails bulkFilePage={currentPage} applicableContacts={applicableContacts}/>}

        <div className="user-match-page-body">
          {!!currentPage.page_image_url ?
            <Img src={currentPage.page_image_url}
                 loader={<div className="page-image-loading">
                <FontAwesome name="spinner" spin/>
              </div>}
            /> :
            <div className="page-image-loading">
              <FontAwesome name="spinner" spin/>
            </div>
          }
        </div>

        <div className='user-match-page-footer'>
          <div className='user-match-page-footer-content'>
            {
              page > 0 && (
                <Link
                  className='btn btn-primary'
                  to={`/setup/bulk_file_workflows/${bulkFileWorkflow.id}/${page-1}`}
                  disabled={!!this.state.submitting}
                >
                  <FontAwesome name='chevron-left'/>&nbsp;
                  Prev
                </Link>
              )
            }

            &nbsp;

            <div className='user-match-page-footer-contact-select'>
              <Select
                options={orderedContacts}
                className={applicableContacts.length > 0 ? 'with-applicable-contacts' : ''}
                value={currentPage.contact_id || orderedContacts[0]}
                onChange={({ value = null }) => this.setContact(value)}
                filterOption={
                  (option, filter) => option.canonical_label
                    && option.canonical_label.toLowerCase().includes(filter.toLowerCase())}
              />
            </div>

            &nbsp;

            {
              page < bulkFilePages.length && (
                <React.Fragment>
                  <Link
                    className='btn btn-primary'
                    to={`/setup/bulk_file_workflows/${bulkFileWorkflow.id}/${page + 1}`}
                    disabled={!!this.state.submitting}
                  >
                    Next&nbsp;
                    <FontAwesome name='chevron-right' />
                  </Link>
                  &nbsp;
                  <Link
                    className='btn btn-success'
                    to={`/setup/bulk_file_workflows/${bulkFileWorkflow.id}/${bulkFilePages.length}`}
                    disabled={!!this.state.submitting}
                  >
                    Skip to confirmation step
                  </Link>
                </React.Fragment>
              )
            }
          </div>
        </div>
      </div>
    </ScrollToTop>;
  }

  renderOverview(){
    const { bulkFileWorkflow, bulkFilePages } = this.props;
    const unmappedPages = bulkFilePages.filter((page) => !page.contact_id || page.contact_id === 'UNMATCHED');
    const { commitErrors } = this.props;

    return <div className='bulk-file-workflow-overview'>
      <Link className='bulk-file-workflow-back' to='/setup/bulk_file_workflows'>
        <FontAwesome name='chevron-left' />
        &nbsp;Back to Bulk File Upload list
      </Link>

      <div>
        <PageHeader
          header={
            (
              <span>
                Bulk File Upload:&nbsp;
                {bulkFileWorkflow.checklist_item.name}
                &nbsp;for&nbsp;
                {bulkFileWorkflow.school_year.name}

                <a
                  href={`/api/bulk_file_workflows/${bulkFileWorkflow.id}/download`}
                  className='bulk-file-workflow-download btn btn-success'
                >
                  <FontAwesome name='download' />
                  &nbsp;Download Original Document
                </a>
              </span>
            )
          }
        />

      </div>

      { commitErrors &&
        <div className="alert alert-danger">
          We're sorry.  Something went wrong saving this document.  Please try again.
        </div>
      }

      <ManagedResourceList
        fetchItems={() => Promise.resolve}
        items={bulkFilePages}
        displayType="Page"
        emptyListMessage="No pages were found in the document you uploaded.  Please check the file and try again.  We support: single images, multiple-page PDFs, and ZIP files containing multiple images or PDFs."
        columns={[
          {header: 'Page Number', value: item => item.page_number + 1},
          {header: 'Matched To', value: item => {
            const {contact} = item;
            if (contact){
              return <a href={`/contacts/${contact.id}`} target="_blank">
                {contact.last_name}, {contact.first_name}
                &nbsp;<FontAwesome name="external-link"/>
              </a>;
            }
            else {
              return "NOT MATCHED";
            }
          }}
        ]}
        itemButtons={[
          ({item}) => bulkFileWorkflow.status == 'user_matching' &&
            <Link className="managed-list-item-action btn btn-xs btn-primary" to={`/setup/bulk_file_workflows/${bulkFileWorkflow.id}/${item.page_number}`}>
              <FontAwesome name="edit"/> Edit Match
            </Link>
        ]}
        tableClassName="table-striped"
        rowClassName={item => (item.contact_id && item.contact_id !== "UNMATCHED") ? 'bulk-file-page-matched' : 'bulk-file-page-unmatched error'}
        collectionButtons={[]}
      />

      {bulkFileWorkflow.status == 'user_matching' && <div className="bulk-file-commit">

        <h2>Submit Files</h2>

        <p>Once you submit these files, they will be associated with the selected contacts' answers for "{bulkFileWorkflow.checklist_item.name}".</p>
        {!!unmappedPages.length && <p className="alert alert-warning">
          <strong><FontAwesome name="warning"/>&nbsp; Warning: </strong>
          {unmappedPages.length} unmatched pages will be discarded.
        </p>}

        <div>
          <Link className="btn" to={`/setup/bulk_file_workflows/${bulkFileWorkflow.id}/${bulkFilePages.length-1}`}>
            <FontAwesome name="chevron-left"/>&nbsp;
            Revise Matches
          </Link>&nbsp;
          <button type="button"
                  className="btn btn-primary"
                  onClick={()=> this.commitWorkflow()}
                  disabled={!!this.state.submitting}
          >
            {this.state.submitting && <FontAwesome name="spinner" spin/>}
            Submit Matches
          </button>
        </div>

      </div>}

      {bulkFileWorkflow.status == 'finished' && <div className="bulk-file-committed">
        <h2>Files Processed</h2>
        <p>These files have already been processed and attached to the selected contacts.</p>

        <Link className="btn" to={`/setup/bulk_file_workflows`}>
          <FontAwesome name="chevron-left"/>&nbsp;
          Back to Matching
        </Link>
      </div>}
    </div>;
  }

  renderFailed() {
    return <div className="bulk-file-workflow-overview">
      <Link className='bulk-file-workflow-back' to='/setup/bulk_file_workflows'>
        <FontAwesome name='chevron-left' />
        &nbsp;Back to Bulk File Upload list
      </Link>

      <PageHeader header={`Bulk File Upload Failed`}/>

      <div className="alert alert-danger">
        <p>We're sorry.  Something went wrong processing this upload.  Please try again.</p>
      </div>
    </div>;
  }

  render(){
    const { bulkFileWorkflow } = this.props;
    const { bulkFilePages } = this.props;
    const { duckMeta } = this.props;
    const { page } = this.props;
    const { getWorkflow, commitWorkflow } = this.props;
    const { status } = bulkFileWorkflow;
    const { applicableContacts } = this.props;

    if(applicableContacts.ready && status) {
      if (status == 'pending') {
        return this.renderWaiting({
          reason: "Pending",
          explanation: "Your document has been uploaded and is awaiting processing."
        });
      }
      else if (status == 'processing') {
        return this.renderWaiting({
          reason: "Processing Pages",
          explanation: "Your document has been uploaded and is being processed."
        })
      }
      else if (status == 'ocr_matching') {
        return this.renderWaiting({
          reason: "Smart Matching",
          explanation: <div>
            <div>Our machine learning algorithm is analyzing your document and determining the best possible match for
              each page.
            </div>
            <div>Once we're through, you'll be able to review the matches.</div>
          </div>
        });

        // TODO : Should we add an "I'm feeling lucky" button?
      }
      else if (status == 'committing') {
        return this.renderWaiting({
          reason: "Completing",
          explanation: "We're saving your documents to the contacts you selected.  This process will finish in the background, so feel free to leave this page at any time."
        });
      }
      else if (status == 'finished' || page >= bulkFilePages.length) {
        return this.renderOverview();
      }
      else if (status == 'user_matching') {
        return this.renderUserMatching();
      }
      else if (status == 'failed') {
        return this.renderFailed();
      }
    }

    return this.renderWaiting({
      reason: "Loading"
    });
  }
}

function mapStateToProps(state, props) {
  return {
    applicableContacts: bulkFileWorkflows.applicableContacts(state, props.bulkFileWorkflowId),
    pageErrors: state.bulkFileUploader.errors.pageErrors,
    commitErrors: state.bulkFileUploader.errors.commitErrors
  };
}

function mapDispatchToProps(dispatch, props) {
  return {
    getWorkflow: (id) =>
      dispatch(bulkFileWorkflows.actions.get(id)).then(() =>
        dispatch(bulkFilePages.actions.load(
          {bulk_file_workflow_id: props.bulkFileWorkflowId},
          stringParams({bulk_file_workflow_id: props.bulkFileWorkflowId}
          )
        ))
      ),
    getApplicableContacts: (id) => dispatch(bulkFileWorkflows.actions.loadApplicableContacts(id)),
    updatePage: (page) => dispatch(bulkFilePages.actions.update(page)),
    commitWorkflow: (workflow) => dispatch(bulkFileWorkflows.actions.commit(workflow)),
    rotatePage: (page, rotation) => dispatch(bulkFilePages.actions.rotate(page, rotation))
  };
}

function mapDucksToProps(ownProps) {
  return {
    bulkFileWorkflow: singleDuck(bulkFileWorkflows, ownProps.bulkFileWorkflowId),
    bulkFilePages: filterDuck(bulkFilePages, { bulk_file_workflow_id: ownProps.bulkFileWorkflowId })
  };
}

export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(BulkFileWorkflow);
